const root = document.querySelector('script[data-ml-cart-root]')?.dataset.mlCartRoot || '/';
const states = new WeakMap();
const fingerprint = drawer => {
  const products = drawer.querySelector('[aria-label="Cart Products"]');
  return products ? products.textContent + Array.from(products.querySelectorAll('a[href]'), a => a.getAttribute('href')).join('|') : '';
};
const refresh = async (drawer, state) => {
  const signature = state.signature;
  try {
    const url = new URL(`${root}cart`, window.location.origin);
    url.searchParams.set('section_id', 'ml-cart-support');
    const response = await fetch(url, { credentials:'same-origin', cache:'no-store' });
    if (!response.ok) return;
    const html = await response.text();
    if (!drawer.isConnected || signature !== fingerprint(drawer)) return;
    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const delivery = fragment.querySelector('[data-ml-cart-delivery]');
    const accessories = fragment.querySelector('[data-ml-cart-accessories]');
    const checkout = drawer.querySelector('.Vtl-CartDrawerCheckout__CheckoutButtonContainer');
    const offers = drawer.querySelector('.Vtl-CartDrawer__Container-Content-BottomContainer');
    if (!delivery || !checkout || !offers) return;
    const open = drawer.querySelector('[data-ml-cart-accessories]')?.open;
    const pickupOpen = drawer.querySelector('[data-ml-cart-delivery] details')?.open;
    drawer.querySelectorAll('[data-ml-cart-delivery], [data-ml-cart-accessories]').forEach(element => element.remove());
    if (pickupOpen && delivery.querySelector('details')) delivery.querySelector('details').open = true;
    checkout.before(delivery);
    if (accessories) {
      accessories.open = Boolean(open);
      offers.append(accessories);
    }
    drawer.classList.add('ml-cart-enhanced');
  } catch { }
};
const sync = () => {
  document.querySelectorAll('.Vtl-CartDrawer').forEach(drawer => {
    const signature = fingerprint(drawer);
    let state = states.get(drawer);
    if (!signature) {
      if (state) clearTimeout(state.timer);
      drawer.querySelectorAll('[data-ml-cart-delivery], [data-ml-cart-accessories]').forEach(element => element.remove());
      drawer.classList.remove('ml-cart-enhanced');
      states.delete(drawer);
      return;
    }
    if (state?.signature === signature) return;
    if (state) clearTimeout(state.timer);
    state = { signature, timer:null };
    states.set(drawer, state);
    state.timer = setTimeout(() => refresh(drawer, state), 180);
  });
};
new MutationObserver(sync).observe(document.body, { childList:true, subtree:true, characterData:true });
sync();
